module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"count":"{count} 件"},"link":{"view_activity":"アクティビティを表示"}},"en":{"label":{"count":"{count} events"},"link":{"view_activity":"View Activity"}}}')
  delete Component.options._Ctor
}
